import {createBlocksModel} from '@wix/yoshi-flow-editor/blocks';
import {ChoiceItem} from '../../utils/optionChoicesUtils';
import {OptionButtonWidgetEvents as Events, OptionButtonWidgetMethods as Methods} from './config/constants';

export default createBlocksModel({
  widgetName: 'optionButtonWidget',
  props: {
    shouldShowTitle: {
      type: 'boolean',
      defaultValue: true,
    },
    label: {
      type: 'text',
      defaultValue: '',
    },
    selections: {
      type: undefined,
      defaultValue: [] as ChoiceItem[],
    },
    selectionIds: {
      type: undefined,
      defaultValue: [] as number[],
    },
    isError: {
      type: 'boolean',
      defaultValue: false,
    },
    errorMessage: {
      type: 'text',
      defaultValue: 'false',
    },
  },
  methods: {
    [Methods.Focus]: {},
  },
  events: {
    [Events.Change]: {},
  },
});
